module.exports = __webpack_public_path__ + "img/shorthair-unisex.aa5e9992.svg";